import BreadCrumb from './BreadCrumb'
import withBreadCrumb from './withBreadCrumb'

const ConnectedBreadCrumb = withBreadCrumb(BreadCrumb)

export { ConnectedBreadCrumb as BreadCrumb }
